import { defineMessages } from 'react-intl';

export const scope = 'app.components.Communication.PreviewPanel';

export const messages = defineMessages({
  previewAsLabel: { id: `${scope}.previewAsLabel`, defaultMessage: 'Preview as' },
  renderVariablesFrom: {
    id: `${scope}.renderVariablesFrom`,
    defaultMessage: 'Render variables from'
  },
  emptyAudience: {
    id: `${scope}.emptyAudience`,
    defaultMessage: 'No recipients match the selected contexts'
  },
  recipientFellOut: {
    id: `${scope}.recipientFellOut`,
    defaultMessage: 'That recipient is no longer in the audience — showing the first recipient instead.'
  },
  noContent: {
    id: `${scope}.noContent`,
    defaultMessage: 'Add message content to preview how it will look.'
  },
  emailHeading: { id: `${scope}.emailHeading`, defaultMessage: 'Email' },
  smsHeading: { id: `${scope}.smsHeading`, defaultMessage: 'Text message' },
  noSubject: { id: `${scope}.noSubject`, defaultMessage: '(No subject)' },
  smsLengthVaries: {
    id: `${scope}.smsLengthVaries`,
    defaultMessage: 'Length varies by recipient'
  }
});
